<template>
  <div class="subtitle-1 grey--text text--darken-3 font-weight-medium">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Subtitle'
}
</script>
